import { AuthenticationService } from 'src/app/core/services/auth.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemParams, DgActionColumnWidth, DgColumnDataType, DgColumnWidths, eSimApiPaths } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { firstValueFrom } from 'rxjs';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';


const apiPath             =environment.eSimApi+eSimApiPaths.UserGroups;
const exportFilenameSuffix="User-Groups-Data";
const popUpTitle          ="User Groups";

@Component({
  selector: 'user-groups',
  templateUrl: './user-groups.component.html',
  styleUrls: ['./user-groups.component.scss']
})

export class UserGroupsEmbeddedComponent implements OnInit {
  
  @Input() addUserGroup: number | undefined;
  @Input() companyId   : number | undefined;
  @Input() groupView   : boolean=false;
  @Input() newUser     : boolean=false;
  @Input() userId      : number | undefined;
  @Input() userView    : boolean=false;

  @Output() addButtonClick   : EventEmitter<void>   =new EventEmitter<void>    ();
  @Output() deleteButtonClick: EventEmitter<number> =new EventEmitter<number>  ();
  @Output() editButtonClick  : EventEmitter<number> =new EventEmitter<number>  ();
 
  @ViewChild('gridView',       { static: false }) gridView!       : GridViewComponent;
  
  private gridViewDefaults!: GridViewDefaults;
  
  public curUser           : SystemUserDTO;
  public dgApiPath!        : DgApiPath | undefined;
  public dgActionColumn!   : DgActionColumn | undefined;
  public dgColumns!        : Array<DgColumn>;
  public dgPopup!          : DgPopup | undefined;
  public dgProperties!     : DgProperties | undefined;
  public endDate           : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  public gridHasBeenClicked: boolean=false;
  public gridViewRowId     : number | undefined;
  public gotDgProperties   : boolean=false;
  public startDate         : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  
  constructor(
    private authenticationService     : AuthenticationService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private encryptionService         : EncryptionService,
    private exceptionsService         : ExceptionsService,
    private gridViewService           : GridViewService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
  }

  public async ngOnInit(): Promise<void> {
    try {
      if (this.userId == undefined && this.companyId == undefined && !this.newUser) {
        throw new Error("UserGroupsEmbeddedComponent - UserId/CompanyId cannot be determined");
      }

      await this.setUpDgApiPaths();
      this.setUpDgActionColumn();
      this.setUpDgColumns();
      this.setUpDgPopup();
      this.setUpDgProperties();

      this.gotDgProperties=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private async setUpDgApiPaths(): Promise<void> {
    try {
      this.dgApiPath            =this.gridViewDefaults.setUpDgApiPaths(apiPath);
      this.dgApiPath!.refreshGet=() => this.setDgApiPathGet(false);

      await this.setDgApiPathGet(false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn() {
    try {
      this.dgActionColumn                =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumn!.allowAdding   =false;
      this.dgActionColumn!.allowDeleting =true;
      this.dgActionColumn!.allowUpdating =this.groupView;
      this.dgActionColumn!.allowMore     =false;
      this.dgActionColumn!.deleteIcon    ="assets/images/_suresim/Button Remove 55x23.png";
      this.dgActionColumn!.overrideDelete=true;
      this.dgActionColumn!.visible       =true;
      this.dgActionColumn!.width         =this.groupView
                                          ? DgActionColumnWidth.twoButtonsWithLeftRightPadding
                                          : DgActionColumnWidth.oneButtonWithLeftRightPadding;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopup() {
    try {
      this.dgPopup               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopup!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getEntityId() {
    return ((this.userId ?? -1) > -1 ? this.userId : this.companyId)
  }

  private setUpDgProperties() {
    try {
      this.dgProperties                    =this.gridViewDefaults.setUpDgProperties("", exportFilenameSuffix + "-" + this.getEntityId());
      this.dgProperties!.focusedRowUnselect=false;
      this.dgProperties!.gridKey           ="EmbeddedUserGroups";
      this.dgProperties!.showAddButton     =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumns() {
    try {
      let dgColumn: DgColumn | undefined;
      
      //ID
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.formVisible       =false;
      dgColumn!.gridVisible       =this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumn!.width             =DgColumnWidths.id;
      this.dgColumns              =[dgColumn!];

      //GroupName
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("groupName", "Group", "", DgColumnDataType.string);
      dgColumn!.width             =170;
      this.dgColumns.push(dgColumn!);

      if (this.groupView) {
        //UserCount
        dgColumn                    =this.gridViewDefaults.setUpDgColumn("userCount", "Users In Group", "", DgColumnDataType.number);
        dgColumn!.width             =170;
        this.dgColumns.push(dgColumn!);
  
        //AlertCount
        dgColumn                    =this.gridViewDefaults.setUpDgColumn("alertCount", "Alerts Using Group", "", DgColumnDataType.number);
        dgColumn!.width             =170;
        this.dgColumns.push(dgColumn!);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
 
  public gridAddButtonClick(e:any) {
    try {
      this.addButtonClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridDeleteButtonClick(e:any) {
    try {
      if (this.userView) {
        let allocationId: number | undefined = e.row.data["allocationID"];
        
        if (allocationId==undefined || <number>allocationId<=0) {
          throw new Error("UserGroupComponent.gridDeleteButtonClick().allocationId cannot be determined");
        }
  
        this.deleteButtonClick.emit(allocationId);
      }
      if (this.groupView) {
        let groupId: number | undefined = e.row.data["id"];
        
        if (groupId==undefined || <number>groupId<=0) {
          throw new Error("UserGroupComponent.gridDeleteButtonClick().groupId cannot be determined");
        }
  
        this.deleteButtonClick.emit(groupId);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridEditButtonClick(e:any) {
    try {
      let groupId: number | undefined = e.row.data["id"];
      
      if (groupId==undefined || <number>groupId<=0) {
        throw new Error("UserGroupComponent.gridEditButtonClick().groupId cannot be determined");
      }

      this.editButtonClick.emit(groupId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridRowClick(e:any) {
    try {
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshGrid() {
    this.setDgApiPathGet(true);
  }

  public async setDgApiPathGet(refreshGrid: boolean): Promise<void> {
    try {
      if (this.userId == undefined && this.companyId == undefined)
        throw new Error("UserGroupsComponent - UserId/CompanyId cannot be determined");

      if ((this.userId ?? -1) > 0) {
        const userIdToEncrypt=<string>(this.userId ?? -1).toString();
        const userIdEncResult=await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(userIdToEncrypt, true));
        const userIdEncSS    =userIdEncResult.result;
        
        this.dgApiPath!.get=environment.eSimApi +
                            eSimApiPaths.UserGroups + '/' +
                            eSimApiPaths.UserGroupsGetUserGroupsForUser +
                            "?userIdEncSS=" + userIdEncSS;
      } else {
        const companyIdToEncrypt=<string>(this.companyId ?? -1).toString();
        const companyIdEncResult=await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(companyIdToEncrypt, true));
        const companyIdEncSS    =companyIdEncResult.result;
        
        this.dgApiPath!.get=environment.eSimApi +
                            eSimApiPaths.UserGroups + '/' +
                            eSimApiPaths.UserGroupsGetUserGroupsForCompany +
                            "?companyIdEncSS=" + companyIdEncSS;
      }

      if (refreshGrid) {
        this.gridViewService.apiPathGet=this.dgApiPath!.get;
        this.gridView.refreshData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
